import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetActivityTypeQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetActivityTypeQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/activity-types/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}